module.exports = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || `https://communitytoolbox.herokuapp.com/api`,
  REACT_APP_TOKEN_KEY: 'community-toolbox-auth-token',
  REACT_APP_BASKET_KEY: 'community-toolbox-basket',
  REACT_APP_USER_ID_KEY: 'community-toolbox-logged-in-user',
  MAPS_API_KEY: process.env.REACT_APP_MAPS_API_KEY
}